import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useEffect } from 'react';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

export default function PrivacidadPage() {
  useEffect(() => {
    try {
      window.scrollTo(0, 0);
    } catch (e) {
      console.warn('Unable to scroll to top:', e);
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Política de Privacidad | Desguace Barcelona"
        description="Consulta la política de privacidad de Desguace Barcelona. Información sobre el tratamiento de datos personales, derechos RGPD y protección de datos."
        keywords="política de privacidad, protección de datos, RGPD, Desguace Barcelona"
        canonical={`${siteUrl}/privacidad`}
        noIndex={true}
      />
      <Navbar />
      <main>
        <section className="pt-32 pb-8 bg-[#1a2332]">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-bold text-white font-[Poppins] mb-3">
              Política de Privacidad
            </h1>
            <p className="text-gray-300 text-base">Última actualización: enero 2025</p>
          </div>
        </section>

        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <article className="prose prose-gray max-w-none">
              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#responsable" className="hover:text-[#ff6b35] transition-colors">
                    1. Responsable del Tratamiento
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">
                  El responsable del tratamiento de sus datos personales es{' '}
                  <strong>Desguace Barcelona</strong>, con domicilio social en Barcelona,
                  España. Puede contactarnos a través del teléfono{' '}
                  <strong>932 932 913</strong> o mediante nuestro formulario de contacto en
                  la web.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Nos comprometemos a proteger la privacidad de nuestros usuarios y
                  clientes, cumpliendo con el Reglamento General de Protección de
                  Datos (RGPD) y la Ley Orgánica 3/2018 de Protección de Datos
                  Personales y garantía de los derechos digitales (LOPDGDD).
                </p>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#datos-recogidos" className="hover:text-[#ff6b35] transition-colors">
                    2. Datos que Recogemos
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">
                  Recogemos los siguientes datos personales cuando usted utiliza
                  nuestros servicios de{' '}
                  <strong>tasación de vehículos en Barcelona</strong>, compra de
                  coches siniestrados o averiados:
                </p>
                <ul className="space-y-2 ml-4 mb-4">
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0" />
                    <span>
                      <strong>Datos de identificación:</strong> nombre, apellidos,
                      DNI/NIE.
                    </span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0" />
                    <span>
                      <strong>Datos de contacto:</strong> teléfono, correo
                      electrónico, dirección postal.
                    </span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0" />
                    <span>
                      <strong>Datos del vehículo:</strong> matrícula, marca,
                      modelo, estado del vehículo.
                    </span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-checkbox-circle-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0" />
                    <span>
                      <strong>Datos de navegación:</strong> dirección IP, tipo de
                      navegador, páginas visitadas.
                    </span>
                  </li>
                </ul>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#finalidad" className="hover:text-[#ff6b35] transition-colors">
                    3. Finalidad del Tratamiento
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">
                  Sus datos personales serán tratados con las siguientes finalidades:
                </p>
                <ul className="space-y-2 ml-4">
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0" />
                    <span>Gestionar las solicitudes de tasación y compra de vehículos.</span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0" />
                    <span>Contactar con usted para ofrecerle una valoración de su coche.</span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0" />
                    <span>Gestionar la recogida y el pago del vehículo.</span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0" />
                    <span>Enviar comunicaciones comerciales si ha dado su consentimiento.</span>
                  </li>
                  <li className="text-gray-600 text-sm flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#ff6b35] mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0" />
                    <span>Cumplir con las obligaciones legales aplicables.</span>
                  </li>
                </ul>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#legitimacion" className="hover:text-[#ff6b35] transition-colors">
                    4. Base Legal del Tratamiento
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  La base legal para el tratamiento de sus datos es el consentimiento
                  que usted nos otorga al rellenar nuestros formularios, la ejecución
                  del contrato de compraventa del vehículo, y el cumplimiento de
                  obligaciones legales. En el caso de comunicaciones comerciales, la
                  base legal es su consentimiento expreso, que puede retirar en
                  cualquier momento.
                </p>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#conservacion" className="hover:text-[#ff6b35] transition-colors">
                    5. Conservación de los Datos
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Sus datos personales se conservarán durante el tiempo necesario
                  para cumplir con la finalidad para la que fueron recogidos y para
                  determinar las posibles responsabilidades derivadas de dicha
                  finalidad. Los datos relativos a transacciones de compraventa se
                  conservarán durante un mínimo de 6 años conforme a la legislación
                  fiscal vigente.
                </p>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#destinatarios" className="hover:text-[#ff6b35] transition-colors">
                    6. Destinatarios de los Datos
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Sus datos no serán cedidos a terceros salvo obligación legal.
                  Podrán tener acceso a sus datos los proveedores de servicios
                  necesarios para la gestión (transporte, gestorías administrativas)
                  bajo las debidas garantías de confidencialidad y seguridad.
                </p>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#derechos" className="hover:text-[#ff6b35] transition-colors">
                    7. Sus Derechos
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  Usted tiene derecho a ejercer los siguientes derechos en relación
                  con sus datos personales:
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {[
                    {
                      icon: 'ri-eye-line',
                      title: 'Acceso',
                      desc: 'Conocer qué datos tratamos sobre usted.',
                    },
                    {
                      icon: 'ri-edit-line',
                      title: 'Rectificación',
                      desc: 'Corregir datos inexactos o incompletos.',
                    },
                    {
                      icon: 'ri-delete-bin-line',
                      title: 'Supresión',
                      desc: 'Solicitar la eliminación de sus datos.',
                    },
                    {
                      icon: 'ri-hand-heart-line',
                      title: 'Oposición',
                      desc: 'Oponerse al tratamiento de sus datos.',
                    },
                    {
                      icon: 'ri-lock-line',
                      title: 'Limitación',
                      desc: 'Limitar el tratamiento en ciertos casos.',
                    },
                    {
                      icon: 'ri-share-forward-line',
                      title: 'Portabilidad',
                      desc: 'Recibir sus datos en formato estructurado.',
                    },
                  ].map((item) => (
                    <div
                      key={item.title}
                      className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg"
                    >
                      <div className="w-8 h-8 flex items-center justify-center bg-[#ff6b35]/10 rounded-md flex-shrink-0">
                        <i className={`${item.icon} text-[#ff6b35] text-base`} />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-[#1a2332]">
                          {item.title}
                        </p>
                        <p className="text-xs text-gray-500">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mt-4">
                  Para ejercer estos derechos, puede contactarnos en el teléfono{' '}
                  <strong>932 932 913</strong>. También tiene derecho a presentar
                  una reclamación ante la Agencia Española de Protección de Datos
                  (AEPD) en{' '}
                  <a
                    href="https://www.aepd.es"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#ff6b35] hover:underline cursor-pointer"
                  >
                    www.aepd.es
                  </a>
                  .
                </p>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#cookies" className="hover:text-[#ff6b35] transition-colors">
                    8. Cookies
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Nuestro sitio web utiliza cookies propias y de terceros para
                  mejorar la experiencia de navegación, analizar el tráfico web y
                  personalizar el contenido. Puede configurar sus preferencias de
                  cookies en cualquier momento a través de la configuración de su
                  navegador. Las cookies técnicas son necesarias para el
                  funcionamiento del sitio y no requieren consentimiento.
                </p>
              </div>

              <div className="mb-10">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#seguridad" className="hover:text-[#ff6b35] transition-colors">
                    9. Seguridad
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Hemos adoptado las medidas técnicas y organizativas necesarias
                  para garantizar la seguridad de sus datos personales y evitar su
                  alteración, pérdida, tratamiento o acceso no autorizado,
                  conforme al estado de la tecnología, la naturaleza de los datos
                  y los riesgos a los que están expuestos.
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-xl font-bold text-[#1a2332] font-[Poppins] mb-4">
                  <a href="#modificaciones" className="hover:text-[#ff6b35] transition-colors">
                    10. Modificaciones
                  </a>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Desguace Barcelona se reserva el derecho de modificar esta
                  Política de Privacidad en cualquier momento. Cualquier cambio será
                  publicado en esta página con la fecha de última actualización.
                  Le recomendamos revisar periódicamente esta política para estar
                  informado sobre cómo protegemos sus datos.
                </p>
              </div>
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
